import { FC } from 'react';
import { Trans, useTranslation } from 'next-i18next';
import UniversalLink from 'src/common/components/UniversalLink';
import Icon from 'src/common/components/IconDS22';
import type { LabeledUrl } from './types';
import styles from './HomepageWorldwideLocations.module.scss';

type ListOfLinksProps = {
  links: LabeledUrl[];
  expand: boolean;
  onShowMoreClick: () => void;
};

const ListOfLinks: FC<ListOfLinksProps> = ({ links, expand, onShowMoreClick }) => {
  const [t] = useTranslation('worldwide-locations');
  const list = expand ? links : links.slice(0, 15);
  return (
    <ul className={styles.list}>
      {list.map((link) => (
        <li
          key={link.url}
          className={styles.link}
        >
          <UniversalLink href={link.url}>
            {/* {link.label} */}
            <Trans
              t={t}
              i18nKey={link.label}
              components={{
                br: <br />,
              }}
            />
          </UniversalLink>
        </li>
      ))}
      {!expand && (
        <li>
          <button
            type="button"
            onClick={onShowMoreClick}
            className={styles.showMore}
          >
            {t('show-more')}
            <Icon id="caret-down" />
          </button>
        </li>
      )}
    </ul>
  );
};
export default ListOfLinks;
